import script from "./WinnerPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WinnerPopup.vue?vue&type=script&setup=true&lang=js"

import "./WinnerPopup.vue?vue&type=style&index=0&id=4f29ebf2&scoped=true&lang=scss"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f29ebf2"]])

export default __exports__